/**
 * プレビュー動画のダウンロードファイル名を生成するユーティリティ
 */

/** yyyymmddhhmmss 形式のタイムスタンプを返す */
function formatTimestamp(): string {
  const now = new Date();
  const pad = (n: number) => n.toString().padStart(2, '0');
  return (
    now.getFullYear().toString() +
    pad(now.getMonth() + 1) +
    pad(now.getDate()) +
    pad(now.getHours()) +
    pad(now.getMinutes()) +
    pad(now.getSeconds())
  );
}

/** ファイル名に使えない文字を除去 */
function sanitize(name: string): string {
  return name.replace(/[\\/:*?"<>|\r\n]/g, '_');
}

/**
 * 商品名を短縮する
 * スペース・ハイフン・カッコなどの区切り文字で分割し、最初のセグメントを最大 maxLen 文字で返す
 */
export function truncateProductName(name: string, maxLen = 10): string {
  const segment = name.split(/[\s\-\(\)（）【】「」\[\]〔〕『』《》、，,]/)[0] || name;
  return sanitize(segment).substring(0, maxLen);
}

/**
 * 単一シナリオ用: {シナリオ名}_preview_yyyymmddhhmmss.mp4
 */
export function previewFilename(scenarioTitle: string): string {
  const safe = sanitize(scenarioTitle).substring(0, 50);
  return `${safe}_preview_${formatTimestamp()}.mp4`;
}

/**
 * 連結用: {商品名}_preview_yyyymmddhhmmss.mp4
 */
export function concatPreviewFilename(productName: string): string {
  const short = truncateProductName(productName);
  return `${short}_preview_${formatTimestamp()}.mp4`;
}

/**
 * シナリオ別ZIP用: {商品名}_preview_yyyymmddhhmmss.zip
 */
export function zipPreviewFilename(productName: string): string {
  const short = truncateProductName(productName);
  return `${short}_preview_${formatTimestamp()}.zip`;
}
